import contactFrag from "./Contact";

const InstanceProvenance = ({ contact = false, notes = false } = {}) => `
  id
  credit
  contactId
  ${
    contact
      ? `contact {
      ${contactFrag(contact)}
    }`
      : ""
  }
  day
  display
  instanceId
  itemId
  month
  ${notes ? "notes" : ""}
  owner
  updatedAt
  year
`;

export default InstanceProvenance;
